/* istanbul ignore file */
export * from './SearchResultPageRecommendations';
